import Vue from 'vue'

import variable from "./variable";

Vue.use(variable)

